// Terms of Service 页面组件 - 简洁白色样式
import React from 'react'
import { Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'

const TermsOfService: React.FC = () => {
  return (
    <div className="min-h-screen bg-white py-8 px-4">
      <div className="max-w-4xl mx-auto">
        {/* 头部导航 */}
        <div className="mb-8">
          <Link 
            to="/register" 
            className="inline-flex items-center text-gray-600 hover:text-gray-900 mb-6"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Register
          </Link>
          <h1 className="text-3xl font-bold text-gray-900">Terms of Service</h1>
          <p className="text-gray-600 mt-2">
            Last updated: {new Date().toLocaleDateString('en-US', { 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            })}
          </p>
        </div>

        {/* 内容 */}
        <div className="prose max-w-none">
          <div className="space-y-8 text-gray-800">
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">1. Service Description</h2>
              <p className="mb-4">
                AI Hub provides a unified API platform for accessing multiple AI models including text generation, 
                image creation, speech synthesis, and other AI capabilities. Our platform serves as a gateway to 113+ 
                AI models across 12 major categories.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">2. User Responsibilities</h2>
              <ul className="list-disc list-inside space-y-2 mb-4">
                <li>Provide accurate registration information</li>
                <li>Maintain the security of your API keys</li>
                <li>Use the service in compliance with applicable laws</li>
                <li>Not attempt to reverse engineer or misuse the platform</li>
                <li>Respect rate limits and usage policies</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">3. Payment and Billing</h2>
              <p className="mb-4">
                Our service operates on a prepaid model. Users must maintain sufficient balance to use API services. 
                Charges are deducted in real-time based on usage. Refunds are handled according to our refund policy.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">4. API Usage Terms</h2>
              <ul className="list-disc list-inside space-y-2 mb-4">
                <li>Rate limits: 1000 requests per minute globally</li>
                <li>API keys are non-transferable and personal</li>
                <li>Prohibited uses include illegal content generation</li>
                <li>Service availability is provided on best-effort basis</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">5. Intellectual Property</h2>
              <p className="mb-4">
                Users retain ownership of content they create through our platform. AI Hub reserves rights to 
                improve services based on aggregated usage patterns while respecting user privacy.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">6. Service Modifications</h2>
              <p className="mb-4">
                We reserve the right to modify, suspend, or discontinue services with reasonable notice. 
                Material changes to terms will be communicated to users in advance.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">7. Contact Information</h2>
              <p className="mb-4">
                For questions about these terms, please contact us at legal@yourdomain.com
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TermsOfService